import React from 'react';
import RenderBodyCopy from '../RenderBodyCopy';
import { CaptionPropTypes } from './Caption.types';
const Caption: React.FC<CaptionPropTypes> = ({
  className,
  bodyCopy
}) => {
  return <RenderBodyCopy className={`mt-[2rem] text-center leading-[1.8rem] [&_*]:text-[1.3rem] [&_*]:font-[300] [&_*]:not-italic text-body-copy--dark ${className}`} bodyCopy={bodyCopy?.json?.content} data-sentry-element="RenderBodyCopy" data-sentry-component="Caption" data-sentry-source-file="Caption.tsx" />;
};
export default Caption;